import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams, useHistory } from "react-router-dom";
// --- Import Redux
import { connect } from "react-redux";
// --- Import Functions
import useMakeRequest from "../../../hooks/useMakeRequest";
// components
import Button from "../../../components/UI/Button/Button";
import Preloader from "../../../components/UI/Preloader/Preloader";
import RefundTextValue from "../RefundTextValue/RefundTextValue";
import RefundReasonSelect from "../RefundReasonSelect.js/RefundReasonSelect";
import RefundQuestionnaire from "../RefundQuestionnaire/RefundQuestionnaire";
import RefundErrorModal from "../RefundErrorModal/RefundErrorModal";
import RefundThankyouPage from "../RefundThankyouPage/RefundThankyouPage";
import RefundNoPurchases from "../RefundNoPurchases/RefundNoPurchases";
import RefundTextareaField from "../RefundTextareaField/RefundTextareaField";
// sass
import "./RefundForm.sass";

// const INVALID = "Invalid";
const REQUIRED = "This is a required field.";
const maxCharacters = (number = 250) => {
  return `Maximum ${number} characters.`;
};

function getDate(timestamp) {
  const a = new Date(timestamp * 1000);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const date = a.getDate();

  const time = `${date} ${month} ${year}`;
  return time;
}

function getProducts(data) {
  const licenses = [];
  for (let i = 0; i < data.length; i += 1) {
    for (let j = 0; j < data[i].products.length; j += 1) {
      for (let l = 0; l < data[i].products[j].licenses.length; l += 1) {
        licenses.push({
          licenseId: data[i].products[j].licenses[l].id,
          licenseAmount: data[i].products[j].licenses[l].amount
            ? data[i].products[j].licenses[l].amount
            : 0,
          licenseCreatedTime: getDate(
            data[i].products[j].licenses[l].created_time
          ),
          display_full_name: data[i].products[j].item_name,
          display_name: data[i].products[j].name_prod,
          display_license: data[i].products[j].license_name,
          product_key: data[i].products[j].product_key,
          localAmount: data[i].products[j].licenses[l].local_amount,
          localCurrency: data[i].products[j].licenses[l].local_currency,
        });
      }
    }
  }
  return licenses;
}
// function validateName(name) {
//   const res = { isValid: true, error: "" };
//   if (name.length <= 0) {
//     res.isValid = false;
//     res.error = REQUIRED;
//     return res;
//   }
//   return res;
// }
// function validateEmail(email) {
//   const res = { isValid: true, error: "" };
//   if (email.length <= 0) {
//     res.isValid = false;
//     res.error = REQUIRED;
//     return res;
//   }
//   if (
//     !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(
//       email
//     )
//   ) {
//     res.isValid = false;
//     res.error = INVALID;
//     return res;
//   }
//   return res;
// }
// function validatePhoneNumber(phone) {
//   const res = { isValid: true, error: "" };
//   // if (phone.length <= 0 || phone === "+") {
//   //   res.isValid = false;
//   //   res.error = REQUIRED;
//   //   return res;
//   // }

//   if (phone.length <= 0) {
//     return res;
//   }

//   if (!/\d[()+-]?/g.test(phone)) {
//     res.isValid = false;
//     res.error = "Only digits starting with +";
//     return res;
//   }
//   if (phone.match(/\d/g).length < 10) {
//     res.isValid = false;
//     res.error = INVALID;
//     return res;
//   }

//   return res;
// }
function validateSelectedProduct(value) {
  const res = { isValid: true, error: "" };
  if (!value || (value && !value.product_key)) {
    res.isValid = false;
    res.error = REQUIRED;
    return res;
  }
  return res;
}
function validateReasonRefund(value, otherValue) {
  const res = { isValid: true, otherIsValid: true, error: "" };
  if (value.value === "") {
    res.isValid = false;
    res.otherIsValid = true;
    res.error = REQUIRED;

    return res;
  }
  if (+value.value === 5 && otherValue?.length <= 0) {
    res.isValid = true;
    res.otherIsValid = false;
    res.error = REQUIRED;
    return res;
  }
  if (+value.value === 5 && otherValue?.length > 250) {
    res.isValid = true;
    res.otherIsValid = false;
    res.error = maxCharacters(250);
    return res;
  }

  return res;
}
function validateActivateDigitalKey(value) {
  const res = { isValid: true, error: "" };
  if (value === "") {
    res.isValid = false;
    res.error = REQUIRED;
    return res;
  }
  return res;
}
function validateAdditionNotes(value) {
  const res = { isValid: true, error: "" };
  if (value.length > 300) {
    res.isValid = false;
    res.error = maxCharacters(300);
    return res;
  }
  return res;
}
function validateApprovePolicy(value) {
  const res = { isValid: true, error: "" };
  if (value === false) {
    res.isValid = false;
    res.error = REQUIRED;
    return res;
  }
  return res;
}

const refundReasons = [
  { value: 1, label: "Didn’t receive the license" },
  { value: 2, label: "Wrong product purchased" },
  { value: 3, label: "Duplicated transaction" },
  { value: 4, label: "Unauthorized transaction" },
  { value: 5, label: "Other" },
];

function RefundForm({ userData }) {
  const { licenseId } = useParams();
  const history = useHistory();
  const pathOnBack = history.location.state?.pathOnBack || "/myApps";

  const [formValue, setFormValue] = useState({
    fullName: `${userData.first_name} ${userData.last_name}`,
    email: userData.email,
    phone: userData.phone,
    productToRefund: {},
    allUserProducts: [],
    refundReason: { label: "", value: "" },
    otherRefundReason: "",
    activateDigitalKey: "yes",
    additionNotes: "",
    approvePolicy: false,
  });
  const [formError, setFormError] = useState({
    productToRefund: "",
    refundReason: "",
    otherRefundReason: "",
    activateDigitalKey: "",
    additionNotes: "",
    approvePolicy: "",
  });
  const [showError, setShowError] = useState(false);
  const [setParams, result, isLoading, hasError, error] = useMakeRequest();
  const [
    requestRefund,
    refundResult,
    refundIsLoading,
    refundHasError,
    refundError,
  ] = useMakeRequest();

  useEffect(() => {
    setParams({
      c: "accountStore",
      a: "userLicenses2",
    });
  }, []);

  function getRefundReason() {
    if (+formValue.refundReason.value === 5) {
      return formValue.otherRefundReason;
    }
    return formValue.refundReason.label;
  }

  function validateForm(newFormValue) {
    let res = true;
    const errors = {};

    // Skip product validation if it's preselected from URL (licenseId present and product matched)
    const hasValidPreselection =
      licenseId && newFormValue.productToRefund?.licenseId;
    const productSelected = hasValidPreselection
      ? { isValid: true, error: "" }
      : validateSelectedProduct(newFormValue.productToRefund);

    const reasonRefund = validateReasonRefund(
      newFormValue.refundReason,
      newFormValue.otherRefundReason
    );
    const activateDigitalKey = validateActivateDigitalKey(
      newFormValue.activateDigitalKey
    );
    const additionNotes = validateAdditionNotes(newFormValue.additionNotes);
    const approvePolicy = validateApprovePolicy(newFormValue.approvePolicy);

    if (!productSelected.isValid) {
      errors.productToRefund = productSelected.error;
    } else {
      errors.productToRefund = "";
    }
    if (!reasonRefund.isValid) {
      errors.otherRefundReason = "";
      errors.refundReason = reasonRefund.error;
    } else if (!reasonRefund.otherIsValid) {
      errors.refundReason = "";
      errors.otherRefundReason = reasonRefund.error;
    } else {
      errors.refundReason = "";
      errors.otherRefundReason = "";
    }
    if (!activateDigitalKey.isValid) {
      errors.activateDigitalKey = activateDigitalKey.error;
    } else {
      errors.activateDigitalKey = "";
    }
    if (!additionNotes.isValid) {
      errors.additionNotes = additionNotes.error;
    } else {
      errors.additionNotes = "";
    }
    if (!approvePolicy.isValid) {
      errors.approvePolicy = approvePolicy.error;
    } else {
      errors.approvePolicy = "";
    }

    if (
      !productSelected.isValid ||
      !reasonRefund.isValid ||
      !reasonRefund.otherIsValid ||
      !activateDigitalKey.isValid ||
      !additionNotes.isValid ||
      !approvePolicy.isValid
    ) {
      res = false;
    } else {
      res = true;
    }

    setFormError({ ...errors });
    return res;
  }
  function checkFormValid() {
    return Object.values(formError).every((value) => {
      if (typeof value === "object") {
        return Object.values(value).every((key) => key === "");
      }
      return value === "";
    });
  }

  function validateField(field, value, ...rest) {
    const validateFuncObj = {
      productToRefund: validateSelectedProduct,
      refundReason: validateReasonRefund,
      otherRefundReason: validateReasonRefund,
      activateDigitalKey: validateActivateDigitalKey,
      additionNotes: validateAdditionNotes,
      approvePolicy: validateApprovePolicy,
    };
    if (!validateFuncObj[field]) {
      return;
    }
    const validateFunc = validateFuncObj[field];
    const { isValid, error: validError } = validateFunc(value, ...rest);
    if (!isValid) {
      setFormError({
        ...formError,
        [field]: validError,
      });
    } else {
      setFormError({
        ...formError,
        [field]: validError,
      });
    }
  }
  function hideErrorField(field) {
    setFormError({
      ...formError,
      [field]: "",
    });
  }

  const handleChange = (field, value) => {
    const newValue = {
      ...formValue,
      [field]: value,
    };
    setFormValue(newValue);
  };
  function submitForm(e) {
    e.preventDefault();
    if (!validateForm(formValue)) {
      return;
    }

    requestRefund({
      c: "front/Refund/Refund",
      a: "refundRequest",
      p: {
        guid: userData.guid,
        cid: userData.cid,
        license_id: formValue.productToRefund.licenseId,
        reason: getRefundReason(),
        additionalInformation: {
          name: formValue.fullName ?? "",
          email: formValue.email ?? "",
          phoneNumber: formValue.phone ?? "",
          questionnaire: {
            "Have you activated your Digital Key?":
              formValue.activateDigitalKey,
          },
          additionalNotes: formValue.additionNotes,
        },
      },
    });
  }

  const onGoBack = () => {
    history.push(pathOnBack);
  };

  useEffect(() => {
    if (!isLoading && result) {
      const products = getProducts(result);
      let selectedProduct = {};

      // If licenseId is provided in URL, try to auto-select the matching product
      if (licenseId) {
        const matchingProduct = products.find((product) => {
          return product.licenseId === +licenseId;
        });
        if (matchingProduct) {
          selectedProduct = matchingProduct;
        }
      }

      setFormValue({
        ...formValue,
        allUserProducts: products,
        productToRefund: selectedProduct,
        refundReason: { label: "", value: "" },
      });
    }
  }, [result, isLoading, licenseId]);

  useEffect(() => {
    if (!isLoading && hasError && error) {
      setFormError({ ...formError, productToRefund: error });
    }
  }, [formError, isLoading, hasError, error]);

  useEffect(() => {
    if (!refundIsLoading && refundHasError && refundError !== "") {
      setShowError(true);
    }
  }, [refundIsLoading, refundHasError, refundError]);

  if (isLoading && !result) {
    return (
      <div className="vh-100">
        <Preloader />
      </div>
    );
  }

  if (result && !result.length) {
    return <RefundNoPurchases />;
  }

  // If no licenseId in URL or product not found, show error
  if (
    !isLoading &&
    result &&
    licenseId &&
    !formValue.productToRefund?.licenseId
  ) {
    return (
      <div className="row justify-content-center">
        <div className="refund">
          <Button
            type="button"
            onClick={onGoBack}
            className="btn btn-transparent btn-blue refund-go-back-btn"
          >
            Back to list
          </Button>
          <div className="col-12 col-lg-8 refund-page">
            <div className="refund-navbar">
              <h3 className="refund-navbar__title">Product Not Found</h3>
            </div>
            <p>
              The requested product could not be found or is not eligible for a
              refund.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {refundResult ? (
        <RefundThankyouPage />
      ) : (
        <div className="row justify-content-center">
          <div className="refund">
            <Button
              type="button"
              onClick={onGoBack}
              className="btn btn-transparent btn-blue refund-go-back-btn"
            >
              Back to list
            </Button>
            <div className="col-12 col-lg-8 refund-page">
              <div className="refund-navbar">
                <h3 className="refund-navbar__title">Refund Request Form</h3>
                <p className="refund-navbar__text-cid">
                  Customer ID <span>{userData.cid}</span>
                </p>
              </div>
              <form className="form" onSubmit={submitForm}>
                <div className="form-field">
                  <p className="form-field__title">Product</p>
                  <RefundTextValue
                    value={formValue.productToRefund.display_name}
                    secondaryValue={formValue.productToRefund.display_license}
                  />
                </div>
                {userData?.first_name && userData?.last_name && (
                  <div className="form-field">
                    <p className="form-field__title">Full Name</p>
                    <RefundTextValue
                      value={`${userData.first_name} ${userData.last_name}`}
                    />
                  </div>
                )}
                {userData?.email && (
                  <div className="form-field">
                    <p className="form-field__title">Email</p>
                    <RefundTextValue value={userData.email} />
                  </div>
                )}
                {userData?.phone && (
                  <div className="form-field">
                    <p className="form-field__title">Phone Number</p>
                    <RefundTextValue value={formValue.phone} />
                  </div>
                )}
                <div className="form-select form-reason">
                  <p className="form-select__title">
                    Reason for Refund{" "}
                    <span
                      className={formError.refundReason !== "" ? "error" : ""}
                    >
                      *
                    </span>
                  </p>

                  <div className="form-reason__input-wrapper">
                    {refundReasons.length > 0 && (
                      <RefundReasonSelect
                        value={formValue.refundReason}
                        placeholder="Reason for Refund"
                        options={refundReasons}
                        onChange={(newValue) => {
                          handleChange("refundReason", newValue);
                        }}
                        onBlur={() => {
                          validateField("refundReason", formValue.refundReason);
                        }}
                        onFocus={() => {
                          hideErrorField("refundReason");
                        }}
                        errorMsg={formError.refundReason}
                      />
                    )}
                    {+formValue.refundReason.value === 5 && (
                      <RefundTextareaField
                        id="otherRefundReason"
                        value={formValue.otherRefundReason}
                        handleValue={(e) => {
                          handleChange("otherRefundReason", e.target.value);
                          validateField(
                            "otherRefundReason",
                            formValue.refundReason,
                            e.target.value
                          );
                        }}
                        onBlur={(e) => {
                          validateField(
                            "otherRefundReason",
                            formValue.refundReason,
                            e.target.value
                          );
                        }}
                        onFocus={() => {
                          hideErrorField("otherRefundReason");
                        }}
                        placeholder="Enter your reason for a refund"
                        symbolsLimit={250}
                        errorMsg={formError.otherRefundReason}
                      />
                    )}
                  </div>
                </div>

                <div className="form-questionnaire">
                  <RefundQuestionnaire
                    title={[
                      "Have you activated",
                      <br key="br" />,
                      "your Digital Key?",
                    ]}
                    name="activateDigitalKey"
                    value={formValue.activateDigitalKey}
                    handleValue={(e) => {
                      handleChange("activateDigitalKey", e.target.value);
                      validateField("activateDigitalKey", e.target.value);
                    }}
                    errorMsg={formError.activateDigitalKey}
                  />
                </div>
                <div className="form-addition-notes">
                  <p className="form-addition-notes__title">
                    Additional notes (optional)
                  </p>
                  <RefundTextareaField
                    id="additionNotes"
                    value={formValue.additionNotes}
                    handleValue={(e) => {
                      handleChange("additionNotes", e.target.value);
                      validateField("additionNotes", formValue.additionNotes);
                    }}
                    onBlur={() => {
                      validateField("additionNotes", formValue.additionNotes);
                    }}
                    onFocus={() => {
                      hideErrorField("additionNotes");
                    }}
                    placeholder="Additional notes (optional)"
                    symbolsLimit={300}
                    errorMsg={formError.additionNotes}
                  />
                </div>
                <div className="form-approve-policy">
                  <input
                    id="approve_policy"
                    type="checkbox"
                    checked={formValue.approvePolicy}
                    onChange={() => {
                      handleChange("approvePolicy", !formValue.approvePolicy);
                    }}
                    onBlur={() => {
                      validateField("approvePolicy", formValue.approvePolicy);
                    }}
                    onFocus={() => {
                      hideErrorField("approvePolicy");
                    }}
                  />
                  <label
                    className={
                      formError.approvePolicy !== "" ? "label-error" : ""
                    }
                    htmlFor="approve_policy"
                  >
                    I confirm my refund request and acknowledge that I agree to
                    the{" "}
                    <a
                      className="form-approve-policy__link"
                      target="_blank"
                      href="/?p=lp_tos"
                      rel="noreferrer"
                    >
                      Refund Policy
                    </a>
                    . I understand that the refunded amount will be returned to
                    the original payment method used.{" "}
                    <span
                      className={formError.approvePolicy !== "" ? "error" : ""}
                    >
                      *
                    </span>
                  </label>
                </div>
                <button
                  type="submit"
                  className={`button ${
                    !checkFormValid() ? "button--novalid" : ""
                  }`}
                  disabled={refundIsLoading}
                >
                  submit
                </button>
              </form>
              <RefundErrorModal
                isOpen={showError}
                errorMsg={refundError}
                onCancel={() => setShowError(false)}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

RefundForm.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
};
RefundForm.defaultProps = {
  userData: null,
};

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
  dataIsLoading: state.userDataStore.userDataIsLoading,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RefundForm);
